var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"artlist-container"},[_c('item-tip'),(_vm.list.length)?_c('new-list',{attrs:{"list":_vm.list,"show-more":_vm.showMore,"stype":_vm.listkey,"title":_vm.title},on:{"articleClick":_vm.articleClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }